"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = phonePrefix;

var _utils = require("../utils");

var _lib = require("../lib");

var _constants = require("../constants");

function phonePrefix(value) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  (0, _utils.assertString)(value);
  var message = options.message,
      countryCode = options.countryCode;
  var defaultRegex = "^".concat(Object.keys(_constants.RX_PHONE_PREFIXES).map(function (k) {
    return _constants.RX_PHONE_PREFIXES[k];
  }).join('|'), "$");
  var label = options.label || 'Field';
  var defaultMsg = "".concat(label, " is not a valid phone prefix");
  var messageOptions = {
    key: key,
    message: message,
    label: label,
    validRegex: validRegex
  };

  if ((0, _utils.checkValueExist)(countryCode)) {
    var code = String(countryCode).toUpperCase();

    if ((0, _utils.checkValueExist)(code)) {
      if (Object.prototype.hasOwnProperty.call(_constants.RX_PHONE_PREFIXES, code)) {
        defaultRegex = _constants.RX_PHONE_PREFIXES[code];
      }
    }
  }

  var validRegex = new RegExp(options.validRegex || defaultRegex, 'i');
  var key = options.key || 'key';
  var validity = (0, _utils.createValidity)(key);

  if (value.length > 0 && !validRegex.test(value)) {
    validity.isValid = false;
    validity.message = (0, _lib.getMessage)(messageOptions, defaultMsg);
  }

  return validity;
}